<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="服务商ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="服务商账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>
                    <el-form-item label="服务商等级" class='tiny' cleartable>
						<el-select v-model="searchInfo.agentLv" placeholder="请选择">
							<el-option key="-1" label="全部" :value="null">全部</el-option>

							<el-option key="0" label="省级服务商" :value="1"></el-option>
							<el-option key="1" label="市级服务商" :value="2"></el-option>
                            <el-option key="2" label="区级服务商" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="月度">
						<div class="block">
                             <el-date-picker
                                v-model="searchInfo.timer"
                                type="month"
                                value-format="yyyy-MM"
                                placeholder="选择日期">
                            </el-date-picker>
						</div>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>

		<el-table class="tables" :data="monthStoreList.list" stripe style="width: 100%;"
			:header-cell-style="headClass" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="120px">
						<el-form-item label="商城订单">
							<span>￥{{ props.row.shopGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.shopOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="">
							<span></span>
						</el-form-item>
					
						<el-form-item label="门店订单">
							<span>￥{{ props.row.storeGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.storeCnt }}笔</span>
						</el-form-item>
						<el-form-item label="门店让利">
							<span>￥{{ props.row.storeRl }}</span>
						</el-form-item>

					
						<el-form-item label="扫码收款">
							<span>￥{{ props.row.scanPayGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.scanPayCnt }}笔</span>
						</el-form-item>
						<el-form-item label="扫码让利">
							<span>￥{{ props.row.scanPayRl }}</span>
						</el-form-item>

						<el-form-item label="客户回馈">
							<span>￥{{ props.row.hkGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.hkOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="客户回馈让利">
							<span>￥{{ props.row.hkRl }}</span>
						</el-form-item>
					
						<el-form-item label="收银台流水">
							<span>￥{{ props.row.sytGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.sytOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="收银台让利">
							<span>￥{{ props.row.sytRl }}</span>
						</el-form-item>
					
						<el-form-item label="卡项">
							<span>￥{{ props.row.kxGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.kxCnt }}笔</span>
						</el-form-item>
						<el-form-item label="卡项让利">
							<span>￥{{ props.row.kxRl }}</span>
						</el-form-item>
					
						<el-form-item label="云连锁核销">
							<span>￥{{ props.row.ylsGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.ylsOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="云连锁核销实收">
							<span>￥{{ props.row.ylsSh }}</span>
						</el-form-item>

						<el-form-item label="采购订单">
							<span>￥{{ props.row.caigouGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.caigouOrderCnt }}笔</span>
						</el-form-item>
					</el-form>

				</template>
			</el-table-column>
			<el-table-column prop="userId" label="服务商ID" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="username" label="服务商账号" align="center"  :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
            <el-table-column prop="logo" label="服务商LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.logo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="month" label="月度" align="center"  :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="agentLv" label="服务商等级" align="center"  :show-overflow-tooltip="true" >
                <template slot-scope="scope">
					<p v-if="scope.row.agentLv==1">省级服务商</p>
                    <p v-if="scope.row.agentLv==2">市级服务商</p>
					<p v-if="scope.row.agentLv==3">区级服务商</p>
				</template>
			</el-table-column>
			
			<el-table-column prop="areaName" label="服务区域" align="center"  :formatter="changeNull">
			</el-table-column>
			<!-- <el-table-column prop="days" label="考核周期(天)" align="center"  :formatter="changeNull">
			</el-table-column> -->
			<el-table-column prop="task1ReachAmount" label="任务一" align="center"  :formatter="changeNull">
				<template slot-scope="scope">
					<p>{{ scope.row.task1 }}</p>
					<span v-if="scope.row.task1ReachAmount<scope.row.task1MinAmount" style="color:#ee3f4d;">{{ scope.row.task1ReachAmount}}</span>
					<span v-else style="color:#2eb487;">{{ scope.row.task1ReachAmount }}</span>
					<span>{{ scope.row.task1Unit }}</span>
					<span>/</span>
					<span>{{ scope.row.task1MinAmount }}</span>
					<span>{{ scope.row.task1Unit }}</span>
				</template>
			</el-table-column>
            <el-table-column prop="task2ReachAmount" label="任务二" align="center"  :formatter="changeNull">
				<template slot-scope="scope">
					<p>{{ scope.row.task2 }}</p>
					<span v-if="scope.row.task2ReachAmount<scope.row.task2MinAmount" style="color:#ee3f4d;">{{ scope.row.task2ReachAmount}}</span>
					<span v-else style="color:#2eb487;">{{ scope.row.task2ReachAmount }}</span>
					<span>{{ scope.row.task2Unit }}</span>
					<span>/</span>
					<span>{{ scope.row.task2MinAmount }}</span>
					<span>{{ scope.row.task2Unit }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="task3ReachAmount" label="任务三" align="center"  :formatter="changeNull">
				<template slot-scope="scope">
					<p>{{ scope.row.task3 }}</p>
					<span v-if="scope.row.task3ReachAmount<scope.row.task3MinAmount" style="color:#ee3f4d;">{{ scope.row.task3ReachAmount}}</span>
					<span v-else style="color:#2eb487;">{{ scope.row.task3ReachAmount }}</span>
					<span>{{ scope.row.task3Unit }}</span>
					<span>/</span>
					<span>{{ scope.row.task3MinAmount }}</span>
					<span>{{ scope.row.task3Unit }}</span>
				</template>
			</el-table-column>

			<el-table-column prop="storeAmount" label="辖区店铺数据" align="center"  :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="spAmount" label="辖区服务商数量" align="center"  :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="shareSpAmount" label="本人分享链接的服务商数量" align="center"  :formatter="changeNull">
			</el-table-column>


			<!-- <el-table-column prop="shopGmv" label="商城金额" align="center"  :formatter="changeNull">
			</el-table-column>

			<el-table-column prop="storeGmv" label="门店金额" align="center"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="storeRl" label="门店让利" align="center"  :formatter="changeNull">
			</el-table-column>

            <el-table-column prop="scanPayGmv" label="扫码金额" align="center"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="scanPayRl" label="扫码让利" align="center"  :formatter="changeNull">
			</el-table-column>

            <el-table-column prop="hkGmv" label="客户回馈金额" align="center"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="hkRl" label="客户回馈让利" align="center"  :formatter="changeNull">
			</el-table-column>

            <el-table-column prop="sytGmv" label="收银台金额" align="center"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="sytRl" label="收银台让利" align="center"  :formatter="changeNull">
			</el-table-column>

            <el-table-column prop="kxGmv" label="卡项金额" align="center"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="kxRl" label="卡项让利" align="center"  :formatter="changeNull">
			</el-table-column>

            <el-table-column prop="ylsGmv" label="云连锁核销金额" align="center"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="ylsSh" label="云连锁核销实收" align="center"  :formatter="changeNull">
			</el-table-column> -->

			<!-- <el-table-column prop="createDate" label="创建时间" width="" align="center" :show-overflow-tooltip="true" >
			</el-table-column> -->
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="monthStoreList.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="monthStoreList.total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				monthStoreList: {}, //用户列表
				dialogVisible: false,
				typeList: [],
				integralList: [],
				integralId: "", //积分id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
                    agentLv: null
				},
				allData: {}
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getmonthStoreList();
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getmonthStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getmonthStoreList()
			},
			
			getmonthStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,

                    month: this.searchInfo.timer,
                    
					userId: this.searchInfo.userId,
					username: this.searchInfo.username,
					phone: this.searchInfo.phone,

                    agentLv: this.searchInfo.agentLv,
                    
				}
				this.$api.fwsMonthResultList(data).then((res) => {
					// console.log('六十六大神了--', res)
					if (res.state == 'success') {
						this.monthStoreList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message)
					}
				})
				
			},
		},
		created() {
			// console.log(this.timelist());
			this.getmonthStoreList();
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
